/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { UserLoginDto } from '@api';

const passwordMatchingValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const passwordField = control.get('password');
  const confirmField = control.get('passwordConfirm');

  const errors =
    !passwordField || !confirmField || passwordField.value !== confirmField.value
      ? { notMatching: true }
      : null;

  confirmField!.setErrors(errors);
  return errors;
};

@Component({
  selector: 'app-user-edit-details-form',
  templateUrl: './user-edit-details-form.component.html',
  styleUrl: './user-edit-details-form.component.scss',
})
export class UserEditDetailsFormComponent implements OnInit {
  @Input() data: UserLoginDto | null = null;
  @Input({ required: true }) submitText!: string;
  @Output() formSubmit = new EventEmitter<UserLoginDto>();

  form = new FormGroup(
    {
      username: new FormControl('', [Validators.required, Validators.minLength(3)]),
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      passwordConfirm: new FormControl('', [Validators.required]),
    },
    { validators: passwordMatchingValidator },
  );

  ngOnInit(): void {
    if (this.data && this.data.username) {
      this.form.controls.username.setValue(this.data.username);
    }
  }

  _onSubmit() {
    if (this.form.valid) {
      this.formSubmit.emit({
        username: this.form.controls.username.value!,
        password: this.form.controls.password.value!,
      });
    } else {
      console.log('Invalid input', this.form);
    }
  }
}
